import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import WebpConverter from '../../components/WebpConverter';

const WebpConverterPage: React.FC = () => (
  <ToolLayout
    title="WebP to PNG/JPG Converter Free Online | AllTools"
    description="Convert WebP images to PNG or JPG format. Free online WebP converter with quality control."
    canonicalPath="/webp-converter"
  >
    <WebpConverter />
  </ToolLayout>
);

export default WebpConverterPage;
